import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Rating from "@mui/material/Rating";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { useField, useFormikContext } from "formik";

import "../../../styles/rating.scss";

const _Rating = (props) => {
  const {
    name = "test",
    score = 0,
    size = undefined,
    readOnly,
    color,
    onChange,
  } = props;
  const formikContext = useFormikContext();

  const handleOnChange = (_, newValue) => {
    if (formikContext && name) {
      formikContext.setFieldValue(name, newValue);
      return;
    }

    onChange && onChange(newValue);
  };

  const iconStyle = size
    ? {
        sx: {
          fontSize: size,
        },
      }
    : {};

  const classNames = ["rating"];

  if (color) classNames.push(`rating--color__${color}`);

  return (
    <div className={classNames.join(" ")}>
      <Rating
        className="rating__icon"
        value={score}
        defaultValue={score}
        precision={0.5}
        icon={<StarRoundedIcon {...iconStyle} />}
        emptyIcon={<StarBorderRoundedIcon {...iconStyle} />}
        onChange={handleOnChange}
        readOnly={readOnly}
      />
    </div>
  );
};

_Rating.propTypes = {
  score: PropTypes.number,
};

export default _Rating;
